import { REQUEST_CATEGORIES, RECEIVE_CATEGORIES, FAILURE_CATEGORIES } from './constants';
import { combineReducers } from 'redux';

/*
 * State shape
 {
     categories: [],
     fetchnig: false,
     error: ''
 }
 */

const categories = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_CATEGORIES:
            return action.response.payload;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CATEGORIES:
            return true;
        case FAILURE_CATEGORIES:
        case RECEIVE_CATEGORIES:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_CATEGORIES:
            return action.response.message;
        case REQUEST_CATEGORIES:
        case RECEIVE_CATEGORIES:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    categories,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/category/reducer.js